import { render } from "./MentionBlock.vue?vue&type=template&id=35be0186"
import script from "./MentionBlock.vue?vue&type=script&lang=ts"
export * from "./MentionBlock.vue?vue&type=script&lang=ts"
script.render = render

export default script